import React, { FC } from 'react';

import { Group } from '@mantine/core';

import cx from './DatasheetTable.module.scss';

const DatasheetTableValue: FC<{
    children: React.ReactNode;
}> = ({ children }) => <Group className={cx.value}>{children}</Group>;

export { DatasheetTableValue };
